<template>
<div class="calendar" style="margin-top:20px;">
   <div class="calendar-header yo-text-bold" style="height:50px;overflow:hidden;" >
      <div class="yo-button yo-valign-text-center" style="float:left;height:50px;" @click="monthBefore"><i class="material-icons">keyboard_arrow_left</i></div>
      <div class="yo-button yo-valign-text-center" style="float:right;height:50px;" @click="monthNext"> <i class="material-icons" >keyboard_arrow_right</i></div>
      <div class="yo-align-center yo-valign-text-center yo-text-l yo-text-uppercase" style="height:50px;margin:0 50px;">{{dateContext | data('MMMM YYYY')}}</div>
   </div>


   <div class="row weekdays">
      <div class="col day yo-align-center yo-text-uppercase yo-text-bold" v-for="(day,index) in days" :key="'D'+index">{{day | maxlenght(1,'')}}</div>
   </div>
   <div class="row dates">
      <div class="col day blank" v-for="(blank,index) in firstDayOfMonth" :key="'B'+index">&nbsp;</div>
      <div class="col day yo-align-center" v-for="(giorni,index) in daysInMonth" :key="'G'+index"
      :class="{
         'current-day': giorni.day == initialDate &amp;&amp; month == initialMonth && year == initialYear
         ,'has-event': giorni.evento.length>0
          ,'no-event': giorni.evento.length<1
      }">

         <div v-if="giorni.evento.length>0">
         <el-popover
         :ref="'day'+giorni.day"
         placement="top-start"
         
         width="300"
         trigger="click"
         >
         <div class="yo-pointer" slot="reference">{{giorni.day}}</div>
         <div class="eventi">
            <div class="evento" v-for="item in giorni.evento" :key="item.id">
               <div class="yo-text-s yo-align-left"><router-link :to="'/evento-home/'+item.id">{{item.titolo }}<div style="color:#353535;">Maggiori info</div></router-link></div>
            </div> 
         </div>
         </el-popover>
            
         </div>
         <div v-else>
            {{giorni.day}}
         </div>
            <!--
            <el-badge :value="giorni.evento.length" class="item">
            <span >{{giorni.day}}</span>
            </el-badge>
            -->
      </div>
      <div class="col day blank" v-for="(blank,index) in (6-lastDayOfMonth)" :key="'L'+index">&nbsp;</div>
   </div>
</div>
</template>

<script>
export default {
    data(){
        return{
          today: this.$moment(),
          dateContext: this.$moment(),
          days: [
             this.$moment().weekday(0).format('dd')
             ,this.$moment().weekday(1).format('dd')
             ,this.$moment().weekday(2).format('dd')
             ,this.$moment().weekday(3).format('dd')
             ,this.$moment().weekday(4).format('dd')
             ,this.$moment().weekday(5).format('dd')
             ,this.$moment().weekday(6).format('dd')
            ]
        }
    },
    computed: {
        year: function () {
          return this.dateContext.format('Y')
        },
        month: function () {
          return this.dateContext.format('MMMM')
        },
        daysInMonth: function () {
          var day,momentDay
          var giorno = {}
          var giorni = []
          for (day = 1; day < this.dateContext.daysInMonth()+1; day++) { 
            
            if(day<10){
              momentDay = this.$moment(this.dateContext.format('YYYY-MM-')+'0'+day)
            }else{
              momentDay = this.$moment(this.dateContext.format('YYYY-MM-')+day)
            }
            giorno = {
              day: day
              ,data:momentDay
              ,evento:[]
            }
            
            for (let item of this.$teras._evento){
              
              //console.log('DAYS '+(this.$moment(item.finisceil)).diff(this.$moment(item.iniziail), 'days'))
              if( momentDay.isBetween(item.iniziail, item.finisceil, null, '[]') && item.tipologiaformazione!=1 ){
                giorno.evento.push(item)
              }
            }
            giorni.push(giorno)
            
          }

         

          return giorni
          //return this.dateContext.daysInMonth();
        },
        currentDate: function () {
          var t = this;
          return this.dateContext.get('date');
        },
        firstDayOfMonth: function () {
          var firstDay = this.$moment(this.dateContext.format('YYYY-MM-01'))
          //this.$moment().weekday(0);
          console.log("firstDay weekday is")
          console.log(firstDay.weekday())
          return firstDay.weekday()
        },
        lastDayOfMonth: function () {
          var lastDay = this.$moment(this.dateContext.format('YYYY-MM-01')).endOf("month")
          console.log("lastDay weekday is")
          console.log(lastDay.weekday())
          return lastDay.weekday()
        },
        initialDate: function () {
          return this.today.get('date')
        },
        initialMonth: function () {
          return this.today.format('MMMM')
        },
        initialYear: function () {
          return this.today.format('Y')
        },
        eventi: function () {
        if(typeof this.$teras._evento == 'undefined')
          return []
        var itemFilter = []
        var day = 0
        var giorno
        for (let item of this.$teras._evento){
          console.log('DAYS '+(this.$moment(item.finisceil)).diff(this.$moment(item.iniziail), 'days'))
          for (day = 0; day < (this.$moment(item.finisceil)).diff(this.$moment(item.iniziail), 'days'); day++) { 
            giorno = this.$moment(item.iniziail).add(day, 'days')
            itemFilter.push(this.$teras.data(giorno,"YYYY-MM-DD"))  
          }   
        }
        return itemFilter
      }
    },
    methods: {
        monthNext: function () {
          this.dateContext = this.$moment(this.dateContext).add(1, 'month')
        },
        monthBefore: function () {
          this.dateContext = this.$moment(this.dateContext).subtract(1, 'month')
        }
    }
}
</script>
<style>
.calendar-header{
   border: 1px solid #379EC2;
   border-bottom:0;
   height:50px;
   margin-right:.1%;
}
.col.day {
   width: 14.28%;
   line-height:40px;
   
   border-left:1px solid #379EC2;
   border-top:1px solid #379EC2;
   color: grey;
}
.col.day:nth-child(7n){
  border-right:1px solid #379EC2;
  width: 14.29%;
}
.col.day.blank{
    background:#eeeeee;
}
.row.dates{
    border-bottom:1px solid #379EC2;
}
.evento{
   margin-bottom:20px;
}
.evento:last-child {
   margin-bottom:0;
}
.day.no-event{
  color:#dddddd;
  background:#f9f9f9;
}
.day.has-event{
  background-color:rgb(167, 209, 224);
  color:#0E1C3C !important;
}
.has-event:hover{
  background-color:#0E1C3C;
  color:#ffffff !important;
}
.current-day{color:red}
</style>



// WEBPACK FOOTER //
// src/components/Calendar.vue